export default __webpack_public_path__ + "static/media/folder-close.8f7e4d09.svg";